module.exports = __webpack_public_path__ + "media/images/htt-painting-a-picture-7565b06fbd83287792c756611b2a19fd.svg";